import React from "react";

export default (props) => (
  <a onClick={props.onClick} className={(props.animationActive) ? 'animation-active' : ''}>
    {(props.animationActive) ? "Pause Movie" : "Play Movie"}
  </a>
);